export const getRecommendationsInitialState = () => ({});
export const getRecommendationsSliceInitialState = () => ({
    headline: '',
    error: null,
    isLoading: false,
    responseId: '',
    products: [],
    productId: undefined,
});
